import { todayIso, isoDaysAgo } from "../utils";
/**
 * Static helpers extracted from CorrectionRequestModal so the main
 * component stays under the code-review complexity ceiling. Pure
 * functions + constants — no state, no side effects, no React.
 *
 * 20 Feb 2026 (Phase 1 of the "gradually reduce complexity" refactor
 * plan). Split intentionally mechanical — behaviour is byte-identical
 * to what used to live at the top of `CorrectionRequestModal.jsx`.
 */

/** Human-readable labels for the "what's wrong?" dropdown. */
export const KIND_LABELS = {
  missed_checkin:    "I forgot to punch in",
  time_adjust:       "My check-in time is wrong",
  leave_date_change: "The dates on my leave are wrong",
  leave_cancel:      "Cancel this leave — shouldn't have run",
  leave_type_change: "Change the leave type",
};

/** Kinds grouped by entity_type — drives the dropdown when the caller
 * hasn't hard-locked a specific kind (e.g. from a generic corrections
 * button). */
export const KINDS_BY_ENTITY = {
  attendance: ["missed_checkin", "time_adjust"],
  leave:      ["leave_date_change", "leave_cancel", "leave_type_change"],
};

/** Latest date a correction can target — corrections are capped at
 * "today" (future dates are never valid). */
export const windowMaxDate = todayIso;

/** Earliest date a correction can target — members: 31-day window;
 * admins: no limit (payroll-locked months are still refused server-side). */
export const windowMinDate = (isAdmin) => (isAdmin ? undefined : isoDaysAgo(31));
